const API_URL =
  process.env.REACT_APP_API_URL || "https://api.mogym.ir";

function authHeader() {
  const token = localStorage.getItem("token");

  return token
    ? {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    : {
        "Content-Type":"application/json"
      };
}

const referralService = {
  async getMyReferral() {
    const res = await fetch(
      `${API_URL}/api/referral/me`,
      {
        headers: authHeader()
      }
    );

    if (!res.ok)
      throw new Error("خطا در دریافت اطلاعات");

    const data=await res.json();

    return data?.result || data;
  },

  async submitWithdrawalRequest(payload){

      const res=await fetch(
      `${API_URL}/api/wallet/withdrawal-request`,
      {
          method:"POST",
          headers:authHeader(),
          body:JSON.stringify(payload)
      });

      if(!res.ok)
        throw new Error("ثبت درخواست ناموفق بود");

      return await res.json();
  }
};

export default referralService;